import React from 'react'
import { ReactComponent as Heart } from '../icons/heart-solid.svg';
import { ReactComponent as Thumb } from '../icons/thumbs-up-solid.svg';
import { ReactComponent as Message } from '../icons/message-regular.svg';
import { ReactComponent as Share } from '../icons/share-solid.svg';

export default function Newscard(props) {
  return (
    <div className='newsCard' key={props.keys}>
        <div className='newsContainer bor'>
        <div className='news-postimg'>
            <img src={props.image} alt={props.image} />
        </div>
        <h2>{props.name}</h2>
        </div>

        <div className='newsPostWrite bor'>
        <p>Fruit Catching with plastic bottle</p>
        </div>

        <div className='newsField'>
        <img src='https://www.postplanner.com/hubfs/how%20to%20write%20a%20facebook%20post.jpg' alt='newsimg' />
        </div>

        <div className='like-sectionh bor'>

        <div className='logos-likes'>
            <div className='like-logo bor'>
            <Heart fill='#ffffff'/>
            </div>
            <span>45k</span>
        </div>

        <div className='cmnt-share'>
            <span>409 Comments</span>
            <span>14k Shares</span>
        </div>
        </div>
        <div className='gullu'>
        <div className='logo-txt'>
            <Thumb fill='#0571ed'/>
            <span>Like</span>
        </div>

        <div className='logo-txt'>
            <Message />
            <span>Comments</span>
        </div>

        <div className='logo-txt'>
            <Share />
            <span>Share</span>
        </div>
        </div>
  </div>
  )
}
